/**
 * sl-728o.3.1: Input Filter Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputFilterSession(t: I18n): TutorialSession {
  return {
    id: 'automation:inputFilter',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="filter-bar-container"]',
        title: t['com.streamlain.streamlain.coach.filter-data.title'](),
        content: t['com.streamlain.streamlain.coach.filter-data.content'](),
        animation: 'pulse',
      },
      {
        targetSelector:
          '[data-coachmark-target="filter-bar-container"] .filter-bar-add-filter',
        title: t['com.streamlain.streamlain.coach.filter-add.title'](),
        content: t['com.streamlain.streamlain.coach.filter-add.content'](),
        animation: 'highlight',
        onEnter: () => {
          const addBtn = document.querySelector(
            '[data-coachmark-target="filter-bar-container"] .filter-bar-add-filter'
          ) as HTMLElement | null;
          addBtn?.click();
        },
        delay: 200,
      },
      {
        targetSelector: 'affine-menu',
        title: t['com.streamlain.streamlain.coach.filter-column.title'](),
        content: t['com.streamlain.streamlain.coach.filter-column.content'](),
        animation: 'highlight',
        onExit: () => {
          document.dispatchEvent(
            new KeyboardEvent('keydown', { key: 'Escape' })
          );
        },
      },
    ],
  };
}
